<template>
  <BaseDialog
    title="回報錯誤"
    width="30%"
    :show-close="false"
    :append-to-body="true"
    :closeOnClickModal="false"
    @close="handleClose"
    @confirm="handleConfirm"
    @cancel="handleClose"
  >
    <FlexLayout col :gap="12" style="margin-bottom: 20px;">
      <p>回報錯誤後，開發團隊將協助您進行問題排查。</p>
    </FlexLayout>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/Dialog/BaseDialog.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'BugReportModal',
  components: {
    BaseDialog,
  },
  setup (props, { emit }) {
    const handleClose = () => {
      emit('close', false)
    }

    const handleConfirm = () => {
      emit('close')
    }

    return {
      handleClose,
      handleConfirm,
    }
  },
})
</script>
